'use client'
import { type Dispatch, type FC, type SetStateAction, useEffect, useState } from 'react'
import { TypeCmsVideo } from '@/schema'
import { calculateAspectRatio, getOrientationFromAspectRatio, getVideoData, TypeExtendedVideoData } from '@/utils'
import dynamic from 'next/dynamic'
import styled from 'styled-components'
import { getP50 } from '@/styles'
import { useModal } from '@/hooks'
import { MODALS } from '@/context'

const DynamicVideoIframe = dynamic(() => import('./VideoIframe').then(mod => mod.VideoIframe), { ssr: false })

type Props = {
  data: TypeCmsVideo
  className?: string
	setVideoLoaded?: Dispatch<SetStateAction<boolean>>
	inModal?: boolean
}

export const VideoGeneric:FC<Props> = ({ data, className, setVideoLoaded, inModal = false }) => {
  const { long_video: longVideo, short_video:shortVideo } = data || {}
  const [videoExtendedData, setVideoExtendedData] = useState<TypeExtendedVideoData>(null)
  const [extendedDataFetched, setExtendedDataFetched] = useState(false)
  const { updatePayload, isActive } = useModal(MODALS.VIDEO)

  useEffect(() => {
    async function getData() {
      const videoData = await getVideoData(longVideo ?? shortVideo, data.platform)
      const aspectRatio = calculateAspectRatio(videoData.width, videoData.height, 'decimal') as number
      const orientation = getOrientationFromAspectRatio(aspectRatio)
      if(videoData && aspectRatio && orientation) setVideoExtendedData({ ...videoData, aspectRatio, orientation })
    }

    if (extendedDataFetched || videoExtendedData?.aspectRatio || (!shortVideo && !longVideo)) return
    else {
      getData()
      setExtendedDataFetched(true)
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
			<DynamicVideoIframe key={data.short_video + inModal} extendedData={videoExtendedData} data={data} {...className && { className }} setVideoLoaded={setVideoLoaded} showControls={(inModal && !!data.long_video)}/>
      {(longVideo && !isActive && !inModal) && (
				<PlayIcon onClick={() => { updatePayload({ payload: { data, extendedData: videoExtendedData}, open: true })}}>
					<span>Play</span>
				</PlayIcon>
			)}
    </>
  )
}

const PlayIcon = styled.button`
  align-items: center;
  /* background-color: var(--color-img-placeholder); */
	background-color: transparent;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 50%;
	opacity: 0;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: height 300ms var(--trasition-ease), width 300ms var(--trasition-ease);
  width: 100%;
  z-index: 2;

	&:hover {
		span {
			border-color: rgba(255, 255, 255, .5);
		}
	}

  span {
		align-items: center;
		border: 1.4px solid transparent;
		border-radius: 100px;
    color: #ffffff;
		display: flex;
		height: 130px;
		justify-content: center;
    ${getP50()}
		padding: 30px;
		transition: border-color 1000ms ease;
		width: 130px;
  }
`
